var _excluded = ["property"];
var _templateObject;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import moment from 'moment';
import upperFirst from 'lodash/upperFirst';
import get from 'lodash/get';
import PropertyHistory from './property-history';
import { jsx as ___EmotionJSX } from "@emotion/core";
var fragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fragment PropertyHistory on Property {\n    address {\n      division {\n        name\n        profile {\n          infoLink\n        }\n      }\n    }\n    history {\n      date\n      transfer {\n        contractDate\n        transferDate\n        transferType\n        purpose\n        price\n        blockSize\n        label\n      }\n      listing {\n        publicVisibleDate\n        daysOnMarket\n        saleMethod\n        media {\n          items(types: PHOTO) {\n            order\n            type\n            imageSrc\n            mediaSrc\n            title\n          }\n        }\n      }\n      agents {\n        agency {\n          name\n        }\n      }\n    }\n  }\n"])));
var DETAILS_MAP = {
  contractDate: 'Contract',
  transferDate: 'Transfer',
  transferType: 'Transfer type',
  purpose: 'Purpose',
  price: 'Price',
  blockSize: 'Block size',
  daysOnMarket: 'Days on market',
  publicVisibleDate: 'Listed'
};
var TRANSFER_TYPE_MAPPING = {
  FULL: 'Full transfer',
  PARTIAL: 'Partical transfer'
};
var DATE_FMT = 'DD/MM/YYYY';
var validateDate = myDate => {
  var momentDate = moment(myDate);
  return momentDate.isValid() ? momentDate.format(DATE_FMT) : null;
};
export var graphQLToProps = function graphQLToProps() {
  var _address$division;
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$history = _ref.history,
    history = _ref$history === void 0 ? [] : _ref$history,
    address = _ref.address;
  var finalProps = {
    suburbInfo: {},
    cards: []
  };
  finalProps.cards = history.map(curr => {
    var result = {
      date: moment(curr.date).format('DD MMM YYYY'),
      photos: get(curr, 'listing.media.items') || [],
      agencyName: get(curr, 'agents[0].agency.name') || '',
      title: curr.transfer.label,
      details: {}
    };
    if (curr.transfer) {
      var _curr$transfer$price;
      result.price = (_curr$transfer$price = curr.transfer.price) === null || _curr$transfer$price === void 0 ? void 0 : _curr$transfer$price.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 0
      });
      result.details = {
        [DETAILS_MAP.contractDate]: validateDate(curr.transfer.contractDate),
        [DETAILS_MAP.transferDate]: validateDate(curr.transfer.transferDate)
      };
    }
    if (curr.listing) {
      result.details = _objectSpread(_objectSpread({}, result.details), {}, {
        [DETAILS_MAP.publicVisibleDate]: validateDate(curr.listing.publicVisibleDate),
        [DETAILS_MAP.daysOnMarket]: curr.listing.daysOnMarket
      });
    }
    if (curr.transfer) {
      result.details = _objectSpread(_objectSpread({}, result.details), {}, {
        [DETAILS_MAP.blockSize]: curr.transfer.blockSize && "".concat(curr.transfer.blockSize, "m\xB2"),
        [DETAILS_MAP.transferType]: TRANSFER_TYPE_MAPPING[curr.transfer.transferType],
        [DETAILS_MAP.purpose]: upperFirst(curr.transfer.purpose ? curr.transfer.purpose.toLowerCase() : '')
      });
    }
    return result;
  });
  if (address !== null && address !== void 0 && (_address$division = address.division) !== null && _address$division !== void 0 && _address$division.profile) {
    finalProps.suburbInfo = {
      name: address.division.name,
      link: address.division.profile.infoLink
    };
  }
  return finalProps;
};
var PropertyHistoryGraphQL = _ref2 => {
  var property = _ref2.property,
    props = _objectWithoutProperties(_ref2, _excluded);
  return ___EmotionJSX(PropertyHistory, _extends({}, graphQLToProps(property), props));
};
PropertyHistoryGraphQL.fragment = fragment;
PropertyHistoryGraphQL.propTypes = {
  property: PropTypes.shape({
    history: PropTypes.arrayOf(PropTypes.shape({
      date: PropTypes.string,
      transfer: PropTypes.shape({
        contractDate: PropTypes.string,
        transferDate: PropTypes.string,
        transferType: PropTypes.oneOf(['FULL', 'PARTIAL']),
        purpose: PropTypes.string,
        price: PropTypes.number,
        blockSize: PropTypes.number
      }),
      listing: PropTypes.shape({
        publicVisibleDate: PropTypes.string,
        saleMethod: PropTypes.string,
        daysOnMarket: PropTypes.number
      }),
      agents: PropTypes.arrayOf(PropTypes.shape({
        agency: PropTypes.shape({
          name: PropTypes.string
        })
      }))
    })),
    address: PropTypes.shape({
      division: PropTypes.shape({
        name: PropTypes.string,
        profile: PropTypes.shape({
          infoLink: PropTypes.string
        })
      })
    })
  }),
  isOnMarket: PropTypes.bool
};
PropertyHistoryGraphQL.defaultProps = {
  property: {},
  isOnMarket: false
};
export default PropertyHistoryGraphQL;